export const prepaymentFilterState = () => ({
  searchKey: "",
  page: 1,
  perPage: 10,
});
